var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 13.333H3.33333C2.59695 13.333 2 12.7361 2 11.9997V2.66634C2 1.92996 2.59695 1.33301 3.33333 1.33301H12.6667C13.403 1.33301 14 1.92996 14 2.66634V11.9997C14 12.7361 13.403 13.333 12.6667 13.333H11.6667M8 12.6663C9.10457 12.6663 10 11.7709 10 10.6663C10 9.56177 9.10457 8.66634 8 8.66634C6.89543 8.66634 6 9.56177 6 10.6663C6 11.7709 6.89543 12.6663 8 12.6663ZM8 12.6663L8.01429 12.6662L5.88578 14.7947L4.00016 12.9091L6.0131 10.8962M8 12.6663L10.1285 14.7947L12.0142 12.9091L10.0012 10.8962M6 3.99967H10M4.66667 6.33301H11.3333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.2e76c2bd496ad745cf333c53a4327002.svg";
export { ForwardRef as ReactComponent };